import { Stack, Typography } from "@mui/material";

const PreviewWrapper = ({ label, value }) => {
  return (
    <Stack
      flex={1}
      p={1.5}
      bgcolor="grey.gb"
      sx={{ borderRadius: 1.5 }}
      alignItems="start"
      justifyContent={"flex-start"}
    >
      <Typography variant="body1" color="text.secondary" textAlign="left">
        {label}:
      </Typography>
      {typeof value !== "string" ? (
        value
      ) : (
        <Typography variant="body1" color="text.primary" textAlign="left">
          {value?.toString().trim() ? value : "\u00A0"}
        </Typography>
      )}
    </Stack>
  );
};

export default PreviewWrapper;
